import React from 'react';
import { TextField } from 'material-ui';

function LinerMeter({ linerMeter, linerMeterDisabled, changeFieldsMultiple, modifiedFields = null, underStyle = null }) {

    return (
        <TextField 
            name='linerMeter'
            floatingLabelText='Liner meter, m'
            value={linerMeter || ''}
            onChange={e => changeFieldsMultiple([{field: 'linerMeter', value: parseFloat(e.target.value)}])}
            disabled={linerMeterDisabled}
            underlineStyle={modifiedFields && modifiedFields.includes('linerMeter') ? underStyle : null}
            fullWidth
        />
    );
}

export default LinerMeter;



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/LinerMeter.jsx